import React from 'react';
import s from './PopupManagerInfo.module.css';
import style from '../PopupsCommonStyle.module.css';
import {OrderViewType} from '../../../../types/TypesUserOrders';
import GreenButton from '../../../../Components/Buttons/GreenButton';
import {useTranslation} from 'react-i18next';
import {
	orderStatusTranslate,
	deliveryStatusTranslate,
	deliveryTypeTranslate,
	paymentMethodTranslate,
} from '../../../../assets/utils/translatersFunc';

interface Props {
	orderInfo: OrderViewType;
	close: () => void;
}
const PopupManagerInfo: React.FC<Props> = ({orderInfo, close}) => {
	const {t} = useTranslation();
	return (
		<div className={style.wrapper}>
			<div className={style.container}>
				<div className={s.title}>
					{t('Інформація про замовлення')}
				</div>
				<div className={s.id}>№ {orderInfo.order_id}</div>
				<div className={s.content}>
					<div className={s.contentColumn}>
						<div>
							{t('Дата')}: <span>{orderInfo.create_date.split('T')[0]}</span>{' '}
						</div>
						<div>
							{t('Статус доставки')}: <span>{orderStatusTranslate(orderInfo.status)}</span>{' '}
						</div>
						<div>
							{t('Статус оплати')}: <span>
								{orderInfo.status_pay === true ? t('Оплачено') : orderInfo.status_pay === false ? t('Неоплачено') : ''}
							</span>{' '}
						</div>
						<div>
							{t('Тип замовлення')}: <span>
								{orderInfo.deferred === true ? t('Відкладене') : orderInfo.deferred === false ? t('Звичайне') : ''}
							</span>{' '}
						</div>
						<div>
							{t('Країна')}: <span>{orderInfo.country_name}</span>{' '}
						</div>
						<div>
							{t('Місто')}: <span>{orderInfo.city_name}</span>{' '}
						</div>
						<div>
							{t('Коментар до замовлення')}: <span>{orderInfo.comment}</span>{' '}
						</div>
						{/*<div>Отделение/Адрес:<span>отделение</span> </div>*/}
					</div>
					<div className={s.contentColumn}>
						<div>
							{t('Вид оплати')}: <span>{orderInfo.payment_method ? paymentMethodTranslate(orderInfo.payment_method) : ''}</span>{' '}
						</div>
						<div>
							{t('Дата оплати')}: <span>{orderInfo?.pay_date}</span>{' '}
						</div>
						<div>
							{t('Спосіб доставки')}: <span>
								{orderInfo.service_type ? deliveryStatusTranslate(orderInfo.service_type) : ''}
								{orderInfo.service_type && orderInfo.delivery_type ? ' ' : ''}
								{orderInfo.delivery_type ? deliveryTypeTranslate(orderInfo.delivery_type) : ''}
							</span>{' '}
						</div>
						<div>
							{t('Адреса')}: <span>{orderInfo.address_name}</span>
						</div>
						<div>
							{t('Час доставки')}: <span>{orderInfo.delivery_date}</span>{' '}
						</div>
						<div className={s.contact}>
							<span>
								{orderInfo.ware_name} {orderInfo.recipient_name}{' '}
								{orderInfo.recipient_phone}
							</span>
						</div>
						{/*<div>ТТН:<span>11144455522288894</span> </div>*/}
					</div>
				</div>
				<div className={s.buttons}>
					<GreenButton text={'Закрити'} type={'button'} onClick={close} />
					{/*{path !== 'my_orders' && (
							<button className={s.button}>
								<Link to={`/my_orders_manager/edit/${orderInfo.order_id}`}>
									{apiData.button_edit}
								</Link>
							</button>
						)}*/}
				</div>

				{/*{!Boolean(orderInfo) && (
					<div className={s.buttons}>
						<button className={s.button}>
							<Link to={'/' + (path ?? 'my_orders_manager')}>
								{apiData.text_close}
							</Link>
						</button>
					</div>
				)}*/}
				{/*Boolean(orderInfo?) && <div className={s.print}>
                    <img src={printIcon} alt="printIcon"/>
                   Печать
                </div>*/}
			</div>
		</div>
	);
};

export default PopupManagerInfo;
